<template>
    <div id="academic">
        <div class="nav-space"></div>
        <CUHK />
        <DSE />
    </div>
</template>

<script>
import CUHK from '../components/academicSections/CUHK.vue'
import DSE from '../components/academicSections/DSE.vue'

export default {
    name: 'Academic',
    components: { CUHK, DSE },
    mounted(){
        this.$nextTick(() => {
            if(!this.$route.query.location) return
            let location = typeof this.$route.query.location === 'number' ? this.$route.query.location : document.getElementById(this.$route.query.location).offsetTop
            window.scrollTo({
                top: location - 50,
                behavior: 'smooth'
            })
        })
    }
}
</script>

<style scoped>
.nav-space{
    height: 50px;
    background-color: #181e2def;
}
</style>